module.exports = __webpack_public_path__ + "img/mo6.744f240f.png";